import { render, staticRenderFns } from "./InboxReply.vue?vue&type=template&id=945b1c78"
import script from "./InboxReply.vue?vue&type=script&lang=js"
export * from "./InboxReply.vue?vue&type=script&lang=js"
import style0 from "./InboxReply.vue?vue&type=style&index=0&id=945b1c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports